/**
 * NewVersionBanner — carte flottante haut-droite quand un nouveau deploy est
 * detecte par useBuildVersionCheck. Le user clique "Recharger" pour appliquer.
 *
 * Position : top-4 right-4 (et NON bottom-4) — bottom-right est occupe par
 * la bulle Intercom (z-2147483647), qui masquait le banner et empechait
 * d'appliquer les updates. Top-right est la zone de scan naturelle en
 * lecture occidentale + libre de tout widget tiers.
 *
 * Design aligne Cinqo DS (tokens, pas de hex hardcode, shadow violette).
 * Pattern Linear/Notion : persistant, pas dismissible — on force le reload
 * pour eviter qu'un user reste coince sur une ancienne version avec un
 * bundle qui peut casser au prochain lazy import.
 *
 * A11y : role="status" + aria-live="polite" (ne vole pas le focus actif).
 */

import { Button } from '@cinqo/ui'
import { useBuildVersionCheck } from '../lib/useBuildVersionCheck'

export function NewVersionBanner() {
  const newBuildId = useBuildVersionCheck()
  if (!newBuildId) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-4 right-4 z-[200] w-[320px] rounded-xl border border-ink-ghost/40 bg-surface-card p-4 shadow-[0_20px_40px_-10px_rgba(61,46,204,0.35),0_0_0_1px_rgba(255,255,255,0.6)] animate-[cinqo-banner-in_300ms_ease-out]"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <svg className="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 12a9 9 0 1 1-9-9" />
            <polyline points="21 3 21 12 12 12" />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-data font-semibold text-ink">Cinqo Ops a été mis à jour</p>
          <p className="mt-0.5 text-caption text-ink-muted">
            Recharger pour appliquer les changements.
          </p>
          <div className="mt-3">
            <Button
              size="sm"
              onClick={() => window.location.reload()}
              className="w-full"
            >
              Recharger
            </Button>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes cinqo-banner-in {
          0% { opacity: 0; transform: translateY(-12px) scale(0.96); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  )
}
